module.exports = __webpack_public_path__ + "img/VAT Certificate_Jan 2019.840979a1.jpg";